<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/page/dashboard"
        ><i class="icon text-info fa fa-home"></i
      ></a>
    </li>
    <li class="breadcrumb-item active" aria-current="page">
      {{ "Form.ProjectLicense" | translate }}
    </li>
  </ol>
</nav>

<div class="row">
  <div class="col-md-12">
    <!--   <div style="margin-bottom: 0 !important">
      <table>
        <thead class="_tas-custom-row">
          <tr>
            <th style="width: 10%">
              <input
                type="text"
                placeholder="Filter by Transaction Id"
                class="form-control m-1 mb-1 me-1 ms-0"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 9%">
              <input
                type="text"
                placeholder="Filter by Company Name"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 10%">
              <input
                type="text"
                placeholder="Filter by Module Name"
                class="form-control m-1"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 10%">
              <input
                type="text"
                placeholder="Filter by Module Display Name"
                class="form-control m-1"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 10%">
              <input
                type="date"
                placeholder="Filter by Purchase Date"
                class="form-control m-1"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 10%">
              <input
                type="date"
                placeholder="Filter by Valid From"
                class="form-control m-1"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 10%">
              <input
                type="date"
                placeholder="Filter by Valid Upto"
                class="form-control m-1"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 10%"></th>
          </tr>
        </thead>
      </table>
    </div> -->

    <div *ngIf="isLoading" class="loaderdata">
      <div class="spinner-border" role="status">
        <span class="sr-only">{{ "Form.Loading" | translate }}</span>
      </div>
    </div>
    <!-- <ng-template> -->
    <div class="main-card mb-3 card">
      <table
        class="align-middle mb-0 table table-borderless table-striped table-hover"
      >
        <thead class="font-size-lg text-white">
          <tr>
            <th style="width: 20%">
              <div class="d-flex justify-content-between align-items-center">
                {{ "Form.Placeholder.PROJECT_NAME" | translate }}
                <i
                  (click)="changeSort('transactionId')"
                  style="cursor: pointer"
                  class="fa fa-sort"
                ></i>
              </div>
            </th>
            <th style="width: 20%">
              <div class="d-flex justify-content-between align-items-center">
                {{ "Form.purchaseDate" | translate }}
                <i
                  (click)="changeSort('purchaseDate')"
                  style="cursor: pointer"
                  class="fa fa-sort"
                ></i>
              </div>
            </th>
            <th style="width: 20%">
              <div class="d-flex justify-content-between align-items-center">
                {{ "Form.validUpto" | translate }}
                <i
                  (click)="changeSort('validUpto')"
                  style="cursor: pointer"
                  class="fa fa-sort"
                ></i>
              </div>
            </th>
            <th style="width: 20%">
              <div class="d-flex justify-content-between align-items-center">
                {{ "Form.Renewlicense" | translate }}
              </div>
            </th>
            <th style="width: 20%">
              <div class="d-flex justify-content-between align-items-center">
                {{ "Form.TransactionH" | translate }}
              </div>
            </th>
          </tr>
        </thead>
        <tbody *ngIf="!isLoading && data.length; else noData">
          <tr *ngFor="let item of data">
            <td>{{ item?.projectManagement?.name }}</td>
            <td>
              <ng-container *ngIf="item.validUpto; else noDate">
                {{ item.purchaseDate | date : "dd MMM yyyy" }}
              </ng-container>
              <ng-template #noDate>-</ng-template>
            </td>
            <td>
              <ng-container *ngIf="item.validUpto; else noDate">
                {{ item.validUpto | date : "dd MMM yyyy" }}
                <p style="color: grey">
                  ({{ item.validUpto | remainingDays }})
                </p>
              </ng-container>
              <ng-template #noDate>-</ng-template>
            </td>
            <td>
              <button
                (click)="openPaymentPage(item)"
                placement="bottom"
                ngbTooltip="{{ 'Form.Renewlicense' | translate }}"
                class="btn-shadow btn btn-success"
                routerLinkActive="router-link-active"
              >
                {{ "Form.Renewlicense" | translate }}
              </button>
            </td>
            <td>
              <button
                (click)="getTransactionHistory(item)"
                placement="bottom"
                ngbTooltip="{{ 'Form.TransactionH' | translate }}"
                class="btn-shadow btn btn-success"
                routerLinkActive="router-link-active"
              >
                {{ "Form.TransactionH" | translate }}
              </button>
            </td>
          </tr>
        </tbody>
        <ng-template #noData>
          <tbody>
            <tr *ngIf="!isLoading && data.length === 0">
              <td colspan="7" class="text-center">
                {{ "Form.NoDataAvailable" | translate }}
              </td>
            </tr>
          </tbody>
        </ng-template>
      </table>
    </div>
    <!-- </ng-template> -->
  </div>
</div>
